import { useEffect } from 'react';
import './templateReport.less';

const ChecklistReport: React.FC<{
  children: React.ReactElement;
  style?: Partial<CSSStyleDeclaration>;
}> = ({ style, ...props }) => {
  useEffect(() => {
    if (!document.getElementById('templateReport')) {
      document.body.setAttribute('id', 'templateReport');

      if (style) {
        for (const s in style) {
          const styleValue = style[s];

          if (styleValue) {
            document.body.style[s] = styleValue;
          }
        }
      }
    }
  }, []);

  return <div className="templateReport" {...props} />;
};

export default ChecklistReport;
